.nest-input {
  &__label {
    @apply mb-1 mt-2 text-foreground;
  }

  &__control {
    @apply relative w-full my-1 bg-background px-2 py-1 flex border border-input rounded focus-within:border-blue-600 focus:outline-none;

    &--icon,
    &--loading,
    &--clear {
      @apply absolute top-0 bottom-0 m-auto cursor-pointer w-4 h-4;
    }

    &--icon {
      @apply left-4;
    }

    &--loading {
      @apply right-11 cursor-default;
    }

    &--clear {
      @apply right-4;
    }
  }

  &__helper {
    @apply mb-2 mt-2 text-sm text-gray-500 dark:text-gray-400;
  }
}

.nest-input--with-icon {
  .nest-input__control input {
    padding-inline-start: 2rem
  }
}
